/**
 * One line naming a slide, for the slide lists on both instructor screens.
 * Short enough to scan a forty-slide deck with, which is why a quiz shows
 * its question text rather than just "คำถาม".
 */
export function stopLabel(s, findQuestion) {
  if (s.kind === 'quiz') {
    const q = findQuestion(s.order);
    const kind = q?.payload_json?.variant === 'tags' ? 'ตรวจป้ายชื่อ' : { poll: 'โพล', mc: 'คำถาม', checkbox_sim: 'ลองจริง', order: 'เรียงลำดับ', match: 'จับคู่', classify: 'เลือกชนิด', expr: 'เติมตัวดำเนินการ', numeric: 'ตอบตัวเลข' }[q?.type] || 'คำถาม';
    const text = q?.payload_json?.question || q?.payload_json?.instruction || q?.payload_json?.heading || `ข้อ ${s.order + 1}`;
    return `${kind} · ${String(text).slice(0, 48)}`;
  }
  if (s.kind === 'cover') return 'ปก · ห้องรอ';
  if (s.kind === 'objectives') return s.title;
  if (s.kind === 'hand_demo') return s.title || 'พลังของ Python';
  if (s.kind === 'overview') return s.title;
  if (s.kind === 'hook') return `${s.kicker} · ${s.title}`;
  if (s.kind === 'select-type') return s.title;
  if (s.kind === 'divider') return `${s.part} · ${s.title}`;
  if (s.kind === 'step') return `ขั้นที่ ${s.n} · ${s.title}`;
  if (s.kind === 'pipeline') return s.title;
  if (s.kind === 'bill-split') return `${s.kicker} · ${s.title}`;
  if (s.kind === 'calc-trace') return `${s.kicker} · ${s.title}`;
  if (s.kind === 'op-table') return s.title;
  if (s.kind === 'precedence') return s.title;
  if (s.kind === 'glossary') return s.title;
  if (['name-tag', 'name-rules', 'count-measure', 'type-of', 'summary'].includes(s.kind)) return s.title;
  if (s.kind === 'cam-tags') return s.title;
  if (s.kind === 'results') return 'สรุปผลการเรียนรู้';
  if (s.kind === 'outro') return s.title || 'จบบทเรียน';
  return s.kind;
}
